import Pickup from "./Pickup";
export default Pickup;
